module.exports = __webpack_public_path__ + "img/map-1-f.092c61b4.png";